import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import '../timeSheet.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';

function NotesTimesheet() {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [showApprove, setshowApprove] = useState(false);
    const handleClose = () => setShow(false);
    const handleCloseApprove = () => setshowApprove(false);

return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{ xs:12 }} container justifyContent="space-between" alignItems="center">
                    <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Timesheet Management</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Timesheet Management</span>
                    </Grid>
                    <button className='back_buttonminus mb-0' onClick={() => navigate(-1)}>Back</button>
                </Grid>
                <Grid size={{ xs: 12 }} container justifyContent="space-between" alignItems="center" className="mt-5">
                    <Grid size={{ sm:6,xs: 12 }} container className="gap-3">
                        <h4 className='fw-semibold' style={{color:"#C42B7D"}}>HR Training</h4>
                    </Grid>
                    <Grid container>
                        <div className='profile_show'>
                            <img src={require("../../../assets/defaultprofile.svg").default} alt=''/>
                            <div className='profile_sheet_content'>
                                <span className='my-0'>Matthew Johnson</span>
                                <small>EMPLID002345</small>
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container className="mt-4 timesheet_table" justifyContent="space-between">
                    <Grid size={{md:3.9,xs:12}} container flexDirection="column" className="notes_buttonclick">
                        <button>Sunday <span>12/01/2024</span></button>
                        <button className='activenotes_sheet_btn'>Monday <span>12/01/2024</span></button>
                        <button>Tuesday <span>12/01/2024</span></button>
                        <button>Wednesday <span>12/01/2024</span></button>
                        <button>Thursday <span>12/01/2024</span></button>
                        <button>Friday <span>12/01/2024</span></button>
                        <button>Saturday <span>12/01/2024</span></button>
                    </Grid>
                    <Grid size={{ md:8, xs:12}} container className="notes_contentshow" alignContent="flex-start" alignItems="flex-start">
                        <Grid size={{xs:12}} container justifyContent="space-between" alignItems="center" className="notes_showstarts mb-3">
                            <span>10:55 AM</span>
                            <button><FontAwesomeIcon icon={faPenToSquare} /></button>
                        </Grid>
                        <Grid size={{xs:12}} container className="h-75">
                            <textarea className='w-100'/>
                        </Grid>
                        <Grid size={{xs:12}} container justifyContent="flex-end">
                            <button className='registersendbtn2 mb-0'>Save</button>
                        </Grid>
                    </Grid> 
                </Grid>
            </Grid>
            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body>
                <Grid size={{xs:12}} container flexDirection="column" className="regiter_inputs i94validateinput">
                    <span className='mt-0'>Reason for rejection</span>
                    <textarea placeholder='Write points' className='sheet_resontextarea'/>
                    <Grid size={{xs:12}} container justifyContent="flex-end" className="gap-3">
                        <button className='registersendbtn1 mb-2' onClick={handleClose}>
                            Cancel
                        </button>
                        <button className='registersendbtn2 mb-2'>Submit</button>
                    </Grid>
                </Grid>
                </Modal.Body>
            </Modal>
            <Modal
                show={showApprove}
                onHide={handleCloseApprove}
                size="md"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body>
                    <Grid size={{xs:12}} container>
                        <Grid size={{xs:12}} container flexDirection="column" alignItems="center" className="approve_mainsheetmodal">
                            <FontAwesomeIcon className='approve_icon mb-3' icon={faCircleCheck} />
                            <h4>Approve Timesheet</h4>
                            <span>are you sure want to approve this timesheet</span>
                        </Grid>
                        <Grid size={{xs:12}} container justifyContent="center" className="gap-3 approve_mainsheetmodal">
                            <button className='registersendbtn1 mb-2' onClick={handleCloseApprove}>
                                No
                            </button>
                            <button className='registersendbtn2 mb-2'>Yes</button>
                        </Grid>
                    </Grid>
                </Modal.Body>
            </Modal>
        </div>
    </div>
  );
}

export default NotesTimesheet;